<template>
  <div class="w-full rounded overflow-hidden shadow-lg p-4 md:p-6 bg-white">
  <!-- Contenedor principal en 5 columnas -->
    <Loader :loading="isLoading" />
    
    <!-- Contenido principal (se muestra después de la carga) -->
    <div v-if="!isLoading" class="flex flex-col space-y-6">
      <!-- Imagen de portada y perfil -->
      <div class="w-full mb-8">
        <div 
          class="cardheader relative w-full h-48 md:h-[300.738px]" 
          id="profileImage" 
          :style="{ 
            background: `url(${profileImageUrl || defaultBackgroundImageUrl})`, 
            backgroundSize: 'cover', 
            backgroundPosition: 'center', 
            backgroundRepeat: 'no-repeat'
          }">
          
          <!-- Imagen de perfil superpuesta en la parte inferior -->
          <div class="avatar absolute left-4 bottom-0 transform translate-y-1/2">
            <img 
              :alt="`${name} ${last_name}`" 
              :src="profileAvatarUrl || defaultAvatarUrl" 
              class="rounded-full w-26 h-26 border-4 border-white">
          </div>
        </div>
      </div>

      <!-- Información del usuario con margen superior -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-6"><!-- Ajusta el margen superior con mt-6 -->
        <!-- Nombre -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2 flex items-center space-x-1">
            <!-- Ícono de correo electrónico -->
            <svg xmlns="http://www.w3.org/2000/svg" width="1.2rem" height="1.2rem" viewBox="0 0 24 24"><path fill="#26282E" d="M18 15h-2v2h2m0-6h-2v2h2m2 6h-8v-2h2v-2h-2v-2h2v-2h-2V9h8M10 7H8V5h2m0 6H8V9h2m0 
              6H8v-2h2m0 6H8v-2h2M6 7H4V5h2m0 6H4V9h2m0 6H4v-2h2m0 6H4v-2h2m6-10V3H2v18h20V7z"/>
            </svg>
            <span>Nombre</span>
          </label>
          <p class="text-box">{{ name }}</p>
        </div>
        
        <!-- Apellido paterno -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2">Apellido Paterno</label>
          <p class="text-box">{{ last_name }}</p>
        </div>

        <!-- Apellido materno -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2">Apellido Materno</label>
          <p class="text-box">{{ last_second_name }}</p>
        </div>

        <!-- Fecha de nacimiento -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2 flex items-center space-x-1">
            <!-- Ícono de correo electrónico -->
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <g clip-path="url(#clip0_2133_4773)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.625 0C2.72446 0 2.81984 0.0395088 2.89016 0.109835C2.96049 0.180161 3 0.275544 3 0.375V0.75H9V0.375C9 0.275544 9.03951 0.180161 9.10983 0.109835C9.18016 0.0395088 9.27554 0 9.375 0C9.47446 0 9.56984 0.0395088 9.64017 0.109835C9.71049 0.180161 9.75 0.275544 9.75 0.375V0.75H10.5C10.8978 0.75 11.2794 0.908035 11.5607 1.18934C11.842 1.47064 12 1.85218 12 2.25V10.5C12 10.8978 11.842 11.2794 11.5607 11.5607C11.2794 11.842 10.8978 12 10.5 12H1.5C1.10218 12 0.720644 11.842 0.43934 11.5607C0.158035 11.2794 0 10.8978 0 10.5V2.25C0 1.85218 0.158035 1.47064 0.43934 1.18934C0.720644 0.908035 1.10218 0.75 1.5 0.75H2.25V0.375C2.25 0.275544 2.28951 0.180161 2.35984 0.109835C2.43016 0.0395088 2.52554 0 2.625 0V0ZM1.5 1.5C1.30109 1.5 1.11032 1.57902 0.96967 1.71967C0.829018 1.86032 0.75 2.05109 0.75 2.25V3H11.25V2.25C11.25 2.05109 11.171 1.86032 11.0303 1.71967C10.8897 1.57902 10.6989 1.5 10.5 1.5H1.5ZM11.25 3.75H0.75V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H10.5C10.6989 11.25 10.8897 11.171 11.0303 11.0303C11.171 10.8897 11.25 10.6989 11.25 10.5V3.75Z" fill="#151516"/>
              <path d="M9.375 5.25H8.625C8.41789 5.25 8.25 5.41789 8.25 5.625V6.375C8.25 6.58211 8.41789 6.75 8.625 6.75H9.375C9.58211 6.75 9.75 6.58211 9.75 6.375V5.625C9.75 5.41789 9.58211 5.25 9.375 5.25Z" fill="#151516"/>
              </g>
              <defs>
              <clipPath id="clip0_2133_4773">
              <rect width="12" height="12" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <span>BDD</span>
          </label>
          <p class="text-box">{{ format(birthday) }}</p>
        </div>

        <!-- Email -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2 flex items-center space-x-1">
            <!-- Ícono de correo electrónico -->
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3C0 2.60218 0.158035 2.22064 0.43934 1.93934C0.720644 1.65804 1.10218 1.5 1.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V9C12 9.39782 11.842 9.77936 11.5607 10.0607C11.2794 10.342 10.8978 10.5 10.5 10.5H1.5C1.10218 10.5 0.720644 10.342 0.43934 10.0607C0.158035 9.77936 0 9.39782 0 9V3ZM1.5 2.25C1.30109 2.25 1.11032 2.32902 0.96967 2.46967C0.829018 2.61032 0.75 2.80109 0.75 3V3.16275L6 6.31275L11.25 3.16275V3C11.25 2.80109 11.171 2.61032 11.0303 2.46967C10.8897 2.32902 10.6989 2.25 10.5 2.25H1.5ZM11.25 4.03725L7.6815 6.1785L11.25 8.3355V4.038V4.03725ZM11.2245 9.19575L6.95325 6.615L6 7.18725L5.046 6.615L0.7755 9.195C0.818398 9.35432 0.912636 9.49505 1.04362 9.59538C1.1746 9.69572 1.33501 9.75006 1.5 9.75H10.5C10.6649 9.75011 10.8252 9.69587 10.9562 9.59568C11.0872 9.49549 11.1815 9.35493 11.2245 9.19575ZM0.75 8.3355L4.3185 6.1785L0.75 4.03725V8.33475V8.3355Z" fill="#151516"/>
            </svg>
            <span>Email</span>
          </label>
          <p class="text-box">{{ email }}</p>
        </div>

        <!-- Compañía -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2 flex items-center space-x-1">
            <!-- Ícono de correo electrónico -->
            <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24"><path fill="#26282E" d="M18 15h-2v2h2m0-6h-2v2h2m2 6h-8v-2h2v-2h-2v-2h2v-2h-2V9h8M10 7H8V5h2m0 6H8V9h2m0 6H8v-2h2m0 6H8v-2h2M6 
              7H4V5h2m0 6H4V9h2m0 6H4v-2h2m0 6H4v-2h2m6-10V3H2v18h20V7z"/>
            </svg>
            <span>Compañia</span>
          </label>
          <p class="text-box">{{ company_id}}</p>
        </div>

        <!-- Teléfono -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2 flex items-center space-x-1">
            <!-- Ícono de correo electrónico -->
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <g clip-path="url(#clip0_2133_4771)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.73499 0.992803C2.69072 0.935849 2.63483 0.888967 2.57105 0.855272C2.50726 0.821577 2.43703 0.801839 2.36503 0.79737C2.29303 0.792901 2.2209 0.803803 2.15344 0.829352C2.08598 0.8549 2.02472 0.894511 1.97374 0.945553L1.19824 1.7218C0.835994 2.0848 0.702494 2.59855 0.860744 3.0493C1.51755 4.91499 2.58596 6.60887 3.98674 8.0053C5.38319 9.40606 7.07706 10.4745 8.94274 11.1313C9.39349 11.2896 9.90724 11.1561 10.2702 10.7938L11.0457 10.0183C11.0968 9.96733 11.1364 9.90607 11.1619 9.83861C11.1875 9.77114 11.1984 9.69901 11.1939 9.62701C11.1895 9.55501 11.1697 9.48479 11.136 9.421C11.1023 9.35721 11.0554 9.30133 10.9985 9.25705L9.26824 7.91155C9.2074 7.86436 9.13663 7.8316 9.06127 7.81575C8.98592 7.7999 8.90795 7.80137 8.83324 7.82005L7.19074 8.2303C6.9715 8.2851 6.74181 8.28219 6.52403 8.22186C6.30624 8.16154 6.10779 8.04585 5.94799 7.88605L4.10599 6.0433C3.94607 5.88358 3.83024 5.68516 3.76978 5.46738C3.70932 5.24959 3.70629 5.01986 3.76099 4.80055L4.17199 3.15805C4.19067 3.08335 4.19214 3.00538 4.17629 2.93003C4.16044 2.85467 4.12769 2.7839 4.08049 2.72305L2.73499 0.992803ZM1.40749 0.380053C1.53874 0.248765 1.69641 0.146901 1.87005 0.0812242C2.04368 0.0155473 2.2293 -0.0124392 2.41458 -0.000876942C2.59986 0.0106853 2.78056 0.0615316 2.94468 0.148286C3.1088 0.23504 3.25259 0.355717 3.36649 0.502303L4.71199 2.2318C4.95874 2.54905 5.04574 2.9623 4.94824 3.3523L4.53799 4.9948C4.51678 5.07988 4.51793 5.16899 4.54132 5.25349C4.56471 5.33798 4.60955 5.415 4.67149 5.47705L6.51424 7.3198C6.57637 7.38187 6.65351 7.42678 6.73816 7.45018C6.8228 7.47358 6.91206 7.47465 6.99724 7.4533L8.63899 7.04305C8.83145 6.99493 9.03234 6.99119 9.22645 7.03212C9.42057 7.07305 9.60285 7.15757 9.75949 7.2793L11.489 8.6248C12.1107 9.10855 12.1677 10.0273 11.6112 10.5831L10.8357 11.3586C10.2807 11.9136 9.45124 12.1573 8.67799 11.8851C6.69888 11.1887 4.90195 10.0557 3.42049 8.57005C1.93496 7.08881 0.80195 5.29215 0.105494 3.3133C-0.166006 2.5408 0.0777438 1.71055 0.632744 1.15555L1.40824 0.380053H1.40749Z" fill="#26282E"/>
              </g>
              <defs>
              <clipPath id="clip0_2133_4771">
              <rect width="12" height="12" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <span>Teléfono</span>
          </label>
          <p class="text-box">{{ phone }}</p>
        </div>

        <!-- Cargo -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2">Cargo</label>
          <p class="text-box">{{ user.position_id ? cargos.find(cargo => cargo.id === user.position_id)?.name : 'Sin asignar' }}</p>
        </div>

        <!-- Plan -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2">Plan</label>
          <p class="text-box">{{ plan }}</p>
        </div>

        <!-- Tipo de Cuenta -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2">Tipo de Cuenta</label>
          <p class="text-box">{{ account}}</p>
        </div>
        
        <!-- Roles del usuario -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2 flex items-center space-x-1">
            <!-- Ícono de correo electrónico -->
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.125 12.25C13.125 12.25 14 12.25 14 11.375C14 10.5 13.125 7.875 9.625 7.875C6.125 7.875 5.25 10.5 5.25 11.375C5.25 12.25 6.125 12.25 6.125 12.25H13.125ZM6.14425 11.375H13.1058C13.1098 11.3745 13.1139 11.3739 13.118 11.3733L13.125 11.3715C13.1233 11.1405 12.9789 10.4703 12.46 9.8665C11.977 9.30037 11.1283 8.75 9.625 8.75C8.12263 8.75 7.27388 9.30125 6.79 9.8665C6.27113 10.4703 6.12587 11.1414 6.125 11.3715C6.1314 11.3727 6.13782 11.3739 6.14425 11.375ZM9.625 6.125C10.0891 6.125 10.5342 5.94063 10.8624 5.61244C11.1906 5.28425 11.375 4.83913 11.375 4.375C11.375 3.91087 11.1906 3.46575 10.8624 3.13756C10.5342 2.80937 10.0891 2.625 9.625 2.625C9.16087 2.625 8.71575 2.80937 8.38756 3.13756C8.05937 3.46575 7.875 3.91087 7.875 4.375C7.875 4.83913 8.05937 5.28425 8.38756 5.61244C8.71575 5.94063 9.16087 6.125 9.625 6.125ZM12.25 4.375C12.25 4.71972 12.1821 5.06106 12.0502 5.37954C11.9183 5.69802 11.7249 5.9874 11.4812 6.23116C11.2374 6.47491 10.948 6.66827 10.6295 6.80018C10.3111 6.9321 9.96972 7 9.625 7C9.28028 7 8.93894 6.9321 8.62046 6.80018C8.30198 6.66827 8.0126 6.47491 7.76884 6.23116C7.52509 5.9874 7.33173 5.69802 7.19982 5.37954C7.0679 5.06106 7 4.71972 7 4.375C7 3.67881 7.27656 3.01113 7.76884 2.51884C8.26113 2.02656 8.92881 1.75 9.625 1.75C10.3212 1.75 10.9889 2.02656 11.4812 2.51884C11.9734 3.01113 12.25 3.67881 12.25 4.375ZM6.069 8.12C5.71898 8.00978 5.35818 7.93733 4.99275 7.90387C4.78742 7.88435 4.58126 7.87471 4.375 7.875C0.875 7.875 0 10.5 0 11.375C0 11.9586 0.291375 12.25 0.875 12.25H4.564C4.43429 11.9768 4.3696 11.6773 4.375 11.375C4.375 10.4913 4.70487 9.58825 5.32875 8.834C5.54138 8.57675 5.789 8.33612 6.069 8.12ZM4.305 8.75C2.8455 8.7675 2.01688 9.31 1.54 9.8665C1.01762 10.4738 0.875 11.1466 0.875 11.375H3.5C3.5 10.4606 3.78262 9.54975 4.305 8.75ZM1.3125 4.8125C1.3125 4.11631 1.58906 3.44863 2.08134 2.95634C2.57363 2.46406 3.24131 2.1875 3.9375 2.1875C4.63369 2.1875 5.30137 2.46406 5.79366 2.95634C6.28594 3.44863 6.5625 4.11631 6.5625 4.8125C6.5625 5.50869 6.28594 6.17637 5.79366 6.66866C5.30137 7.16094 4.63369 7.4375 3.9375 7.4375C3.24131 7.4375 2.57363 7.16094 2.08134 6.66866C1.58906 6.17637 1.3125 5.50869 1.3125 4.8125ZM3.9375 3.0625C3.47337 3.0625 3.02825 3.24687 2.70006 3.57506C2.37187 3.90325 2.1875 4.34837 2.1875 4.8125C2.1875 5.27663 2.37187 5.72175 2.70006 6.04994C3.02825 6.37813 3.47337 6.5625 3.9375 6.5625C4.40163 6.5625 4.84675 6.37813 5.17494 6.04994C5.50313 5.72175 5.6875 5.27663 5.6875 4.8125C5.6875 4.34837 5.50313 3.90325 5.17494 3.57506C4.84675 3.24687 4.40163 3.0625 3.9375 3.0625Z" fill="#26282E"/>
            </svg>
            <span>Roles</span>
          </label>
          <div class="flex flex-wrap">
            <ul class="list-unstyled">
              <li v-for="role in user.roles" :key="role.id">
                <p class="text-box">{{ role.name }}</p>
              </li>
            </ul>
          </div>
        </div>

        <!-- Sobre mí -->
        <div class="w-full mt-6">
          <label class="text-style-sm block text-gray-700 font-bold mb-2">Estatus</label>
          <p class="text-box"> {{ status }}</p>
        </div>
      </div>
    </div>
    <div class="form-footer fixed bottom-0 left-0 right-0 bg-white p-4 md:relative md:mt-6 md:text-right md:p-0">
      <div class="flex justify-end space-x-4">
        <!-- Botón de Cancelar -->
        <button type="button" @click="$router.push('/users')">
          <span class="custom-secondary-btn">Cancelar</span>
        </button>

        <!-- Botón de Editar -->
        <button @click="editUser(user.id)" class="custom-create-btn">
          <span class="custom-create-btn-text">Editar Perfil</span>
        </button>
      </div>
    </div>
    <head>
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
    </head>
  </div>
</template>

  <script setup>
  import { ref, computed, onMounted } from "vue";
  import axios from "axios";
  import { useStore } from 'vuex';
  import { useRoute } from "vue-router";
  import Loader from '@/components/loaderComponent.vue';
  import defaultAvatarUrl from '@/assets/imgs/1.png';
  import defaultBackgroundImageUrl from '@/assets/imgs/2.png';
  import { useRouter } from "vue-router";

  // Obtener la tienda de Vuex
  const store = useStore();
  const isLoading = ref(false); // Inicializamos isLoading
  //import { useRouter } from "vue-router";
  let session = computed(() => store.getters.getUserSession);
  const route = useRoute();
  let userId = computed(() => route.params.id);
  let router = useRouter();

  //let router = useRouter();
  // Variables reactivas
  let name = ref(null);
  let birthday = ref();
  let email = ref();
  let aboute_me = ref();
  let phone = ref();
  let last_name = ref();
  let last_second_name = ref();
  let status = ref();
  let company_id = ref();
  let plan = ref();
  let account = ref();
  //let step = ref(1);
  //let profile = ref();

  let companies = ref([]); // Declaración de companies
  let user = ref({ company_id: null });
  let cargos = ref([]); // Declaración de cargos
  let profileImageUrl = ref(""); // URL para la imagen de portada
  let profileAvatarUrl = ref(""); // URL para la foto de perfil
  
  // Formato de fecha
  const format = (birthday) => {
    if (!birthday) return "";
    const day = birthday.getDate();
    const month = birthday.getMonth() + 1;
    const year = birthday.getFullYear();
    return `${day}/${month}/${year}`;
  };
  
  // Obtener perfil
  async function getProfile() {
    isLoading.value = true;
    let options = { headers: { 'Authorization': `Bearer ${session.value.token_api}` } };
    
    try {
      const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/broker/profile/${userId.value}`, options);
      
      if (response.status === 200) {
        const info = response.data.resp.info;
        console.log(info.roles);

        name.value = info.name;
        last_name.value = info.last_name;
        last_second_name.value = info.last_second_name;
        email.value = info.email;
        phone.value = info.phone;
        aboute_me.value = info.about_me;
        birthday.value = new Date(info.birthday);
        company_id.value = info.company.name;
        plan.value = info.plan.name;
        account.value = info.account.name;
        user.value.position_id = info.position_id;
        user.value.roles = info.roles;
        status.value = translateStatus(info.status);
        // Solo asignar si los valores no son null
        if (info.profile_img) {
          profileImageUrl.value = `${info.profile_img}`;
        }
        if (info.profile_avatar) {
          profileAvatarUrl.value = `${info.profile_avatar}`;
        }

        console.log(profileImageUrl.value); // Verifica si la URL está correcta
        console.log(info)
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
    } finally {
      isLoading.value = false;
    }
  }
  const translateStatus = (status) => {
    const statusTranslations = {
      active: 'Activo',
      delete: 'Desactivado',
      block: 'Bloqueado',
      pending: 'Pendiente',
      // Agrega más traducciones según sea necesario
    };

    return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
  };
  // Obtener compañías
  async function fetchCompanies() {
    try {
      let options = {
        headers: {
          'Authorization': `Bearer ${session.value.token_api}`
        }
      };
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/companies`, options
      );
  
      if (response.status === 401) {
        store.dispatch('clearUserSession');
      }
  
      if (response.status === 200 && response.data?.resp?.companies) {
        companies.value = response.data.resp.companies; // Cambia esto
      } else {
        console.error("Error en la respuesta de la API: estructura inesperada");
      }
    } catch (error) {
      console.error("Error al obtener las compañías:", error);
    }
  }
  
  
  //obtener los cargos
  async function fetchCargos() {
    try {
      let options = {
        headers: {
          'Authorization': `Bearer ${session.value.token_api}`
        }
      };
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/cargos`, options
      );

      if (response.status === 401) {
        store.dispatch('clearUserSession');
      }

      // Accede a los cargos en response.data.cargos
      if (response.status === 200 && response.data?.cargos) {
        cargos.value = response.data.cargos; 
      } else {
        console.error("Error en la respuesta de la API: estructura inesperada");
      }
    } catch (error) {
      console.error("Error al obtener los cargos:", error);
    }
  }
  
  async function editUser (id) {
    console.log("ID del usuario:", id); // Imprime el ID en la consola
    router.push({ name: 'UserForm', params: { id } }); // Redirige a la ruta 'UserForm' con el ID del usuario
  }
  
  // Llama a la función para obtener los roles al montar el componente
  onMounted(async () => {
    await Promise.all([
      fetchCompanies(),
      fetchCargos(),
      getProfile(),
    ]);
  });  

  // Computed properties
 // const isRoleAdminOrManager = computed(() => {
  //  return session.value && (session.value.role === 'admin' || session.value.role === 'manager');
  //});
  

  </script>
  
  
<style scoped>
    /* Si el label tiene clases predeterminadas de Flowbite/Tailwind, puedes sobrescribirlas */
    ::v-deep .custom-label label {
      @apply text-white;
    }
  
    /* También puedes apuntar directamente al selector completo */
    ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
      @apply text-white;
    }
    body {
      background-color: #ffffff !important;
    }
    
    .avatar {
      border-radius: 50%;
      overflow: hidden;
      width: 120px;
      height: 120px;
      border: 4px solid #fff;
      display: inline-block;
    }
    .text-box {
      @apply text-sm md:text-base break-words;
    }

    .avatar img {
      @apply object-cover;
    }

    /* Asegura que el contenido principal no sea tapado por el botón fixed en móvil */
    @media (max-width: 768px) {
      .form-footer {
        box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
      }
      
      /* Añade padding inferior al contenedor principal para el espacio del botón fixed */
      .w-full.rounded.overflow-hidden {
        padding-bottom: 80px;
      }
    }
  </style>
  